// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"328":"admin","535":"login","799":"institution","835":"audit-logs"}[chunkId] || chunkId) + "." + {"174":"dde591f5","328":"1303c605","521":"16f3ace3","535":"598f98bc","604":"2bd9f641","609":"91733725","626":"4cb025d0","799":"d24adb09","835":"e28b8e0c","926":"2eb8febb","985":"001dca35"}[chunkId] + ".js";
};